/* Mr. DBS, low poly, walking around in whatever shirt is being featured.
 * The product photo (white background knocked out) is slapped onto his chest,
 * the second photo onto his back. Rendered tiny and upscaled at 10 fps so it
 * looks like an old GIF. Eyes come from the HL2 Mr. DBS face texture.
 */
(function () {
  'use strict';

  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var threeP = null;

  function loadThree() {
    if (window.THREE) return Promise.resolve(window.THREE);
    if (threeP) return threeP;
    threeP = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = THREE_URL;
      s.async = true;
      s.onload = function () { window.THREE ? res(window.THREE) : rej(); };
      s.onerror = rej;
      document.head.appendChild(s);
    });
    return threeP;
  }
  function abs(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }
  function loadImg(src) {
    return new Promise(function (res, rej) {
      if (!src) return rej();
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = rej;
      im.src = abs(src);
    });
  }

  /* white background -> transparent (edge flood fill), returns canvas + average shirt color */
  function knockout(im, T) {
    var w = im.naturalWidth, h = im.naturalHeight;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(im, 0, 0);
    var color = '#222';
    try {
      var d = x.getImageData(0, 0, w, h), a = d.data, n = w * h;
      var bg = function (p) { var i = p * 4; return a[i + 3] < 12 || (a[i] >= T && a[i + 1] >= T && a[i + 2] >= T); };
      var seen = new Uint8Array(n), st = new Int32Array(n), sp = 0, p, i;
      var push = function (q) { if (!seen[q] && bg(q)) { seen[q] = 1; st[sp++] = q; } };
      for (i = 0; i < w; i++) { push(i); push((h - 1) * w + i); }
      for (i = 0; i < h; i++) { push(i * w); push(i * w + w - 1); }
      while (sp) {
        p = st[--sp]; var px = p % w;
        if (px > 0) push(p - 1); if (px < w - 1) push(p + 1);
        if (p >= w) push(p - w); if (p < n - w) push(p + w);
      }
      var r = 0, g = 0, b = 0, k = 0;
      for (p = 0; p < n; p++) {
        if (seen[p]) { a[p * 4 + 3] = 0; continue; }
        // sample the shirt body (outer ring of the middle area) for the sleeve / side color
        var yy = (p / w) | 0, xx = p % w;
        if (yy > h * 0.3 && yy < h * 0.85 && (xx < w * 0.32 || xx > w * 0.68) && (p & 7) === 0) {
          r += a[p * 4]; g += a[p * 4 + 1]; b += a[p * 4 + 2]; k++;
        }
      }
      x.putImageData(d, 0, 0);
      if (k) color = 'rgb(' + ((r / k) | 0) + ',' + ((g / k) | 0) + ',' + ((b / k) | 0) + ')';
    } catch (e) { /* tainted canvas: keep the photo as is */ }
    return { canvas: c, color: color };
  }

  /* the chest / back panel: shirt color with the photo pasted on, a little crooked */
  function panel(ko, tilt, mirror) {
    var c = document.createElement('canvas'); c.width = 256; c.height = 300;
    var x = c.getContext('2d');
    x.fillStyle = ko ? ko.color : '#333';
    x.fillRect(0, 0, 256, 300);
    if (ko) {
      // crop the photo to the shirt's torso (where prints live) and stretch it over his chest
      var im = ko.canvas, w = im.width, h = im.height;
      x.save();
      x.translate(128 + (Math.random() * 10 - 5), 150);
      x.rotate(tilt);
      if (mirror) x.scale(-1, 1);
      x.drawImage(im, w * 0.2, h * 0.1, w * 0.6, h * 0.82, -140, -158, 280, 316);
      x.restore();
    }
    return c;
  }

  /* the low poly Mr. DBS himself, shared with the cart toss scene */
  function makeGuy(THREE, front, back, eyesImg) {
  function mat(color, map) {
    var m = new THREE.MeshLambertMaterial({ color: map ? 0xffffff : color, flatShading: true });
    if (map) { m.map = map; }
    return m;
  }
  function tex(canvas) {
    var t = new THREE.CanvasTexture(canvas);
    t.magFilter = THREE.NearestFilter;
    t.minFilter = THREE.NearestFilter;
    return t;
  }
  function box(w, h, d, m, y) {
    var g = new THREE.BoxGeometry(w, h, d);
    g.translate(0, y || 0, 0);
    return new THREE.Mesh(g, m);
  }

  var shirtColor = front ? front.color : (back ? back.color : '#333');
  var SHIRT = mat(shirtColor), SKIN = mat(0xd9a07a), PANTS = mat(0x1c1c26), SHOE = mat(0xf2f2f2), MASK = mat(0x111111);
  var frontTex = tex(panel(front, -0.06, false));
  var backTex = tex(panel(back || front, 0.05, !back)); // no back photo: mirrored front, extra wrong

  /* ---------- the guy ---------- */
  var guy = new THREE.Group();
  var hips = new THREE.Group(); hips.position.y = 8.6; guy.add(hips);

  // torso: [right, left, top, bottom, front, back]
  var FRONT = mat(0, frontTex), BACK = mat(0, backTex);
  var torso = new THREE.Mesh(new THREE.BoxGeometry(4.6, 5.6, 2.3), [SHIRT, SHIRT, SHIRT, SHIRT, FRONT, BACK]);
  torso.geometry.translate(0, 2.9, 0);
  hips.add(torso);
  hips.add(box(4.4, 1.0, 2.2, PANTS, -0.2)); // belt line

  var neck = box(1.1, 0.8, 1.1, SKIN, 6.0); hips.add(neck);

  // head: chunky hexagon balaclava, bobbing late on its own pivot
  var head = new THREE.Group(); head.position.y = 6.3; hips.add(head);
  var skull = new THREE.Mesh(new THREE.CylinderGeometry(1.55, 1.75, 3.0, 6), MASK);
  skull.geometry.translate(0, 1.5, 0);
  skull.rotation.y = Math.PI / 6;
  head.add(skull);
  var cap = new THREE.Mesh(new THREE.ConeGeometry(1.55, 1.0, 6), MASK);
  cap.position.y = 3.5; cap.rotation.y = Math.PI / 6;
  head.add(cap);
  var slitMat = eyesImg ? mat(0, tex((function () {
    var c = document.createElement('canvas'); c.width = eyesImg.width; c.height = eyesImg.height;
    c.getContext('2d').drawImage(eyesImg, 0, 0); return c;
  })())) : SKIN;
  var slit = new THREE.Mesh(new THREE.PlaneGeometry(2.3, 0.8), slitMat);
  slit.position.set(0, 2.0, 1.56);
  slit.rotation.z = 0.04; // crooked, on purpose
  head.add(slit);

  // arms: stiff, mannequin style
  function arm(side) {
    var sh = new THREE.Group(); sh.position.set(side * 2.85, 5.3, 0); hips.add(sh);
    sh.add(box(1.25, 2.2, 1.3, SHIRT, -1.0));       // sleeve
    var el = new THREE.Group(); el.position.y = -2.1; sh.add(el);
    el.add(box(0.95, 2.5, 0.95, SKIN, -1.2));        // forearm
    el.add(box(1.15, 1.0, 1.15, SKIN, -2.9));        // hand
    return { sh: sh, el: el };
  }
  var armL = arm(-1), armR = arm(1);

  function leg(side) {
    var hp = new THREE.Group(); hp.position.set(side * 1.15, 0, 0); hips.add(hp);
    hp.add(box(1.65, 4.3, 1.7, PANTS, -2.1));
    var kn = new THREE.Group(); kn.position.y = -4.2; hp.add(kn);
    kn.add(box(1.5, 4.0, 1.55, PANTS, -2.0));
    var shoe = box(1.75, 0.9, 2.9, SHOE, -4.25); shoe.position.z = 0.55; kn.add(shoe);
    return { hp: hp, kn: kn };
  }
  var legL = leg(-1), legR = leg(1);

  // fake shadow
  var shadow = new THREE.Mesh(new THREE.CircleGeometry(2.8, 8), new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.35 }));
  shadow.rotation.x = -Math.PI / 2; shadow.position.y = 0.05; shadow.scale.set(1.3, 0.8, 1);
  guy.add(shadow);
    return { guy: guy, hips: hips, head: head, torso: torso, armL: armL, armR: armR, legL: legL, legR: legR,
             SHIRT: SHIRT, FRONT: FRONT, BACK: BACK, mat: mat, tex: tex, box: box, shadow: shadow };
  }

  function Walker(root) {
    this.root = root;
    root.setAttribute('data-ready', '1');
    var data = [];
    try { data = JSON.parse(root.querySelector('.dbsw-data').textContent); } catch (e) {}
    if (!data.length) { root.hidden = true; return; }
    this.data = data;
    this.idx = (Math.random() * data.length) | 0;
    this.item = data[this.idx];
    this.swap = (parseFloat(root.getAttribute('data-swap')) || 0) * 1000;
    this.stage = root.querySelector('.dbsw-stage');
    this.cv = root.querySelector('canvas');
    this.mode = root.getAttribute('data-mode') || 'across';
    this.eyes = root.getAttribute('data-eyes');
    this.stage.href = this.item.u;
    var cap = root.querySelector('.dbsw-name');
    if (cap) cap.textContent = this.item.t + (this.item.p ? '  ' + this.item.p : '');
    var self = this;
    this.watchEl = root;
    this.pix = parseInt(root.getAttribute('data-pix'), 10) || 3;
    this.interactive = root.hasAttribute('data-interactive');   // preview page: buttons drive him
    if (this.mode === 'walk') this.mode = 'across';
    if (this.mode === 'underbuy') {
      // product page: move him right under the buy buttons / "More payment options"
      var pf = document.querySelector('.product__info-container product-form, .product__info-container .product-form');
      var host = pf && pf.closest('.product__info-container');
      if (host) {
        var anchor = pf;
        while (anchor.parentElement && anchor.parentElement !== host) anchor = anchor.parentElement;
        host.insertBefore(root, anchor.nextSibling);
        root.classList.add('is-underbuy');
      }
      this.pix = 2;             // finer pixels so the shirt reads
      this.mode = 'across';
    }
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { io.disconnect(); self.boot(); }
    }, { rootMargin: '200px' });
    io.observe(this.watchEl);
  }

  Walker.prototype.boot = function () {
    var self = this, it = this.item;
    Promise.all([
      loadThree(),
      loadImg(it.f).then(function (im) { return knockout(im, 232); }).catch(function () { return null; }),
      loadImg(it.b).then(function (im) { return knockout(im, 232); }).catch(function () { return null; }),
      loadImg(this.eyes).catch(function () { return null; })
    ]).then(function (r) { self.build(r[0], r[1], r[2], r[3]); })
      .catch(function () { self.fallback(); });
  };

  Walker.prototype.fallback = function () {
    var img = document.createElement('img');
    img.src = abs(this.item.f);
    img.alt = this.item.t;
    img.className = 'dbsw-fallback';
    this.stage.textContent = '';
    this.stage.appendChild(img);
  };

  Walker.prototype.build = function (THREE, front, back, eyesImg) {
    var self = this, cv = this.cv;
    var renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas: cv, alpha: true, antialias: false }); }
    catch (e) { return this.fallback(); }
    renderer.setPixelRatio(1);
    renderer.setClearColor(0x000000, 0);

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(30, 2, 1, 400);
    scene.add(new THREE.AmbientLight(0xffffff, 0.62));
    var sun = new THREE.DirectionalLight(0xffffff, 0.75);
    sun.position.set(-6, 14, 10);
    scene.add(sun);

    var G = makeGuy(THREE, front, back, eyesImg);
    var guy = G.guy, hips = G.hips, head = G.head, armL = G.armL, armR = G.armR, legL = G.legL, legR = G.legR;
    var SHIRT = G.SHIRT, FRONT = G.FRONT, BACK = G.BACK, tex = G.tex;
    scene.add(guy);

    /* ---------- sizing: tiny render, big pixels ---------- */
    var PIX = self.pix, halfW = 20;
    function resize() {
      var w = Math.max(60, self.stage.clientWidth), h = Math.max(60, self.stage.clientHeight);
      renderer.setSize(Math.ceil(w / PIX), Math.ceil(h / PIX), false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      // frame the guy: ~20 units tall
      var dist = 50;
      camera.position.set(0, 10.5, dist);
      camera.lookAt(0, 9, 0);
      var visH = 2 * dist * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2));
      halfW = Math.max(1.5, (visH * camera.aspect) / 2 - 4);
    }
    resize();
    window.addEventListener('resize', resize);

    /* ---------- walking ---------- */
    var x = -halfW, dir = 1, turning = 0, facing = 0.55, t0 = performance.now(), last = 0, visible = true;
    var phase = 0;
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(this.watchEl);

    function pose(ph, stiff) {
      var s = Math.sin(ph), c = Math.cos(ph);
      legL.hp.rotation.x = 0.55 * s;  legR.hp.rotation.x = -0.55 * s;
      legL.kn.rotation.x = Math.max(0, -c) * 0.9; legR.kn.rotation.x = Math.max(0, c) * 0.9;
      armL.sh.rotation.x = -0.5 * s * stiff; armR.sh.rotation.x = 0.5 * s * stiff;
      armL.sh.rotation.z = -0.12; armR.sh.rotation.z = 0.12;
      armL.el.rotation.x = -0.15; armR.el.rotation.x = -0.15;
      hips.position.y = 8.6 + Math.abs(Math.cos(ph)) * 0.35;
      hips.rotation.z = 0.05 * s;
      head.rotation.z = 0.16 * Math.sin(ph * 0.5 + 1.3);  // late, wobbly head
      head.rotation.x = 0.06 * Math.sin(ph * 2);
    }

    /* ---------- outfit swaps (homepage): new shirt every few seconds, with a quick spin ---------- */
    var spin = 0, pendingOutfit = null;
    function wear(o) {
      var f = o.front, b = o.back;
      SHIRT.color.set(f ? f.color : (b ? b.color : '#333'));
      FRONT.map = tex(panel(f, -0.06, false)); FRONT.needsUpdate = true;
      BACK.map = tex(panel(b || f, 0.05, !b)); BACK.needsUpdate = true;
      self.item = o.item;
      self.stage.href = o.item.u;
      var cap = self.root.querySelector('.dbsw-name');
      if (cap) cap.textContent = o.item.t + (o.item.p ? '  ' + o.item.p : '');
    }
    var cache = {};
    var outfit = function (i) {
      if (cache[i]) return cache[i];
      var it = self.data[i];
      cache[i] = Promise.all([
        loadImg(it.f).then(function (im) { return knockout(im, 232); }).catch(function () { return null; }),
        loadImg(it.b).then(function (im) { return knockout(im, 232); }).catch(function () { return null; })
      ]).then(function (r) { return { item: it, front: r[0], back: r[1] }; });
      return cache[i];
    };
    if (self.swap && self.data.length > 1) {
      setInterval(function () {
        if (!visible || document.hidden || spin > 0 || pendingOutfit) return;
        var n;
        do { n = (Math.random() * self.data.length) | 0; } while (n === self.idx);
        self.idx = n;
        outfit(n).then(function (o) { pendingOutfit = o; spin = 0.6; });
      }, self.swap);
    }

    /* ---------- held poses (preview page) ---------- */
    var J = {
      aLs: armL.sh.rotation, aLe: armL.el.rotation, aRs: armR.sh.rotation, aRe: armR.el.rotation,
      lL: legL.hp.rotation, lLk: legL.kn.rotation, lR: legR.hp.rotation, lRk: legR.kn.rotation,
      hr: hips.rotation, hd: head.rotation
    };
    var HAND_HIP_L = { aLs: [0, 0, -0.8], aLe: [0, 0, 1.95] }, HAND_HIP_R = { aRs: [0, 0, 0.8], aRe: [0, 0, -1.95] };
    function P(o) { // fill a pose from defaults (arms hanging, standing straight)
      var d = {
        aLs: [0, 0, -0.12], aLe: [-0.15, 0, 0], aRs: [0, 0, 0.12], aRe: [-0.15, 0, 0],
        lL: [0, 0, 0], lLk: [0, 0, 0], lR: [0, 0, 0], lRk: [0, 0, 0],
        hr: [0, 0, 0], hd: [0, 0, 0], hy: 0, gy: 0.3
      };
      for (var a = 0; a < arguments.length; a++) for (var k in arguments[a]) d[k] = arguments[a][k];
      return d;
    }
    var STAND = P({});
    var CROSSED = P({
      aRs: [-0.85, 0, 0.18], aRe: [0, 0, -1.6],
      aLs: [-0.68, 0, -0.18], aLe: [0, 0, 1.6],
      lL: [0, 0, -0.1], lR: [0, 0, 0.1], hd: [0.14, 0, 0], gy: 0
    });
    var VOGUE = [
      P(HAND_HIP_L, HAND_HIP_R, { lL: [0, 0, -0.14], lR: [0, 0, 0.14], hd: [-0.18, 0.35, 0], gy: 0.2 }),          // power stance
      P({ aRs: [0, 0, 2.4], aRe: [0, 0, 1.4], aLs: [0, 0, -2.4], aLe: [0, 0, -1.4],                                   // frame the face
          hr: [0, 0, 0.09], lR: [-0.25, 0, 0], lRk: [0.45, 0, 0], hd: [0, 0, 0.22], hy: -0.25, gy: -0.3 }),
      P(HAND_HIP_L, { aRs: [-1.5, 0, 0.15], aRe: [0, 0, 0], hd: [-0.2, -0.15, 0], gy: 0.15 }),                         // point at YOU
      P(HAND_HIP_R, { hd: [-0.1, 1.25, 0.1], lLk: [0.3, 0, 0], lL: [-0.15, 0, 0], gy: -2.1 }),                        // over the shoulder
      P({ aRs: [0, 0, 1.5], aRe: [0, 0, 1.55], aLs: [0, 0, -1.5], aLe: [0, 0, -1.55],                                 // flex
          lL: [0, 0, -0.18], lR: [0, 0, 0.18], hy: -0.35, hd: [-0.15, 0, 0], gy: 0 }),
      P(HAND_HIP_L, { aRs: [0, 0, 2.65], aRe: [0, 0, 1.95], hr: [0, 0, -0.12], lLk: [0.4, 0, 0], lL: [-0.2, 0, 0],   // hand behind head
          hd: [0, 0, -0.18], gy: 0.4 }),
      P({ aRs: [0, 0, 2.55], aRe: [0, 0, 0], aLs: [0, 0, 0.4], aLe: [0, 0, 0],                                         // disco
          hr: [0, 0, 0.1], lR: [0, 0, 0.2], hd: [-0.2, 0.3, 0], gy: 0.25 })
    ];
    var held = STAND, poseT = 0, vIdx = -1, modeWas = null;
    function apply(p, k) {
      for (var key in J) {
        var r = J[key], v = p[key];
        r.x += (v[0] - r.x) * k; r.y += (v[1] - r.y) * k; r.z += (v[2] - r.z) * k;
      }
      hips.position.y += (8.6 + p.hy - hips.position.y) * k;
      guy.rotation.y += (p.gy - guy.rotation.y) * k;
      guy.position.x += (0 - guy.position.x) * k;
    }
    function wrapAngle(a) { a = (a + Math.PI) % (Math.PI * 2); if (a < 0) a += Math.PI * 2; return a - Math.PI; }

    // remote control for the preview page
    self.root.__dbsw = {
      setMode: function (m) { self.mode = m === 'walk' ? 'across' : m; },
      getMode: function () { return self.mode; },
      wear: function (i) {
        i = ((i % self.data.length) + self.data.length) % self.data.length;
        self.idx = i;
        return outfit(i).then(function (o) { pendingOutfit = o; spin = 0.6; return o.item; });
      },
      count: self.data.length,
      index: function () { return self.idx; }
    };
    self.root.dispatchEvent(new CustomEvent('dbsw:ready', { bubbles: true }));

    function tick(now) {
      requestAnimationFrame(tick);
      if (!visible || document.hidden) return;
      if (now - last < 100) return; // 10 fps, GIF feel
      var dt = Math.min(0.2, (now - (last || now)) / 1000);
      last = now;

      if (self.mode !== modeWas) {
        // coming out of a walk the body may have spun a few laps: normalise so poses ease the short way
        guy.rotation.y = wrapAngle(guy.rotation.y);
        if (self.mode === 'across' || self.mode === 'place') {
          for (var jk in J) J[jk].set(0, 0, 0);   // the walk cycle only drives some axes; clear pose leftovers
          x = Math.max(-halfW, Math.min(halfW, guy.position.x)); turning = 0;
        }
        modeWas = self.mode; poseT = 0; vIdx = -1;
      }

      if (self.mode === 'static') {
        poseT += dt;
        var calm = P({ hy: Math.sin(poseT * 2.2) * 0.12, hd: [0.03, Math.sin(poseT * 0.7) * 0.35, 0.04], gy: 0.3 });
        apply(calm, 0.35);
      } else if (self.mode === 'showoff') {
        poseT -= dt;
        if (poseT <= 0) {
          var n; do { n = (Math.random() * VOGUE.length) | 0; } while (n === vIdx);
          vIdx = n; held = VOGUE[n]; poseT = 1.5;
          self.root.dispatchEvent(new CustomEvent('dbsw:snap', { bubbles: true }));
        }
        apply(held, 0.7); // snap into it. vogue.
      } else if (self.mode === 'hurt') {
        poseT += dt;
        apply(CROSSED, 0.5);
        head.rotation.y = Math.sin(poseT * 9) * 0.5; // slow disappointed "no"
      } else if (self.mode === 'place' || (reduce && !self.interactive)) {
        phase += dt * 7;
        guy.position.x = 0;
        guy.rotation.y = Math.sin((now - t0) / 2600) * 0.9; // slowly turns to show front and back
        pose(phase, 1);
      } else if (turning > 0) {
        // awkward stop at the edge: spin to show the back of the shirt, hold, spin the rest of the way
        turning -= dt;
        var e = 1.6 - Math.max(0, turning), sg = dir > 0 ? 1 : -1, a0 = sg * facing, ang;
        if (e < 0.5) ang = a0 + sg * Math.PI * (e / 0.5);
        else if (e < 0.9) ang = a0 + sg * Math.PI;
        else ang = a0 + sg * Math.PI + sg * (Math.PI - 2 * facing) * Math.min(1, (e - 0.9) / 0.7);
        guy.rotation.y = ang;
        pose(phase, 0.2);
        if (turning <= 0) { dir = -dir; guy.rotation.y = -a0; }
      } else {
        phase += dt * 7.5;
        x += dir * dt * 4.2;
        // he faces the camera at an angle while walking sideways-ish (it's awkward)
        guy.rotation.y = dir > 0 ? facing : -facing;
        if ((dir > 0 && x > halfW) || (dir < 0 && x < -halfW)) { x = Math.max(-halfW, Math.min(halfW, x)); turning = 1.6; }
        guy.position.x = x;
        pose(phase, 1);
        // random twitch
        if (Math.random() < 0.015) armR.sh.rotation.x = -2.6;
      }
      if (spin > 0) {
        // costume change: one fast awkward spin, the new shirt appears halfway through
        spin -= 0.1;
        guy.rotation.y += (1 - spin / 0.6) * Math.PI * 2;
        if (pendingOutfit && spin <= 0.3) { wear(pendingOutfit); pendingOutfit = null; }
      }
      renderer.render(scene, camera);
    }
    requestAnimationFrame(tick);
  };

  window.DBSW = { loadThree: loadThree, loadImg: loadImg, knockout: knockout, panel: panel, makeGuy: makeGuy, abs: abs };

  function initAll() {
    var roots = document.querySelectorAll('.dbsw:not([data-ready])');
    for (var i = 0; i < roots.length; i++) new Walker(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
